import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { workingStart, workingEnd } from 'wfui-digital-core/es/actions';
import globals from '../../globals/globals';
import logger from '../../logger/logger';
import postData from '../../network/post-data';
import getString from '../../strings/get-string';
import { showStopMessage } from '../../store/stop-message/actions';
import { execute } from '../../native-app-bridge/native-app-bridge';
var exceptionTypes = ['INVALID_DATAKEY', 'MISSING_CLIENTAPPID'];

var getBiometricToken = function getBiometricToken(_ref) {
  var accessPoint = _ref.accessPoint;
  return new Promise(function (resolve) {
    // If the biometric navigation request came from the native login
    // screen (fp = 'front porch'), we don't need to request a biometric
    // token. If the request came from our application, we need to request
    // a token.
    if ('fp' !== accessPoint) {
      logger.debug('Biometrics: get native token');

      window.getBiometricTokenCallback = function (response) {
        var _ref2 = _typeof(response) === 'object' ? response : JSON.parse(response),
            result = _ref2.result;

        if (exceptionTypes.includes(result)) {
          logger.debug('Biometrics: "getData" NAB call exception', result);
          resolve();
        } else {
          resolve(result);
        }
      };

      execute('getData', {
        dataKey: 'BA_TOKEN',
        nonce: globals().nonce,
        clientAppID: globals().wfAppId
      }, 'getBiometricTokenCallback');
    } else {
      resolve();
    }
  });
};

export default /*#__PURE__*/(function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
    var navigationItem, store, payload, biometricToken, _yield$postData, biometricViewBean, FailureMessageBean, globalMessages, message;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            navigationItem = _ref3.navigationItem, store = _ref3.store;

            if (!globals().nativeWrapped) {
              _context.next = 28;
              break;
            }

            logger.debug('Biometrics: navigate');
            payload = {};
            _context.next = 6;
            return getBiometricToken(navigationItem);

          case 6:
            biometricToken = _context.sent;

            if (biometricToken) {
              payload.btkn = biometricToken;
            }

            store.dispatch(workingStart());
            _context.prev = 9;
            _context.next = 12;
            return postData({
              url: navigationItem.url,
              data: Object.assign({}, payload),
              includeRootContext: false,
              contentType: 'application/json; charset=utf-8'
            });

          case 12:
            _yield$postData = _context.sent;
            biometricViewBean = _yield$postData.biometricViewBean;
            execute('goNativeScreen', Object.assign({}, biometricViewBean, {
              destinationScreen: 'BioEnrollmentPrefs'
            }));
            store.dispatch(workingEnd());
            _context.next = 26;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
            logger.error('Biometrics: navigation error', _context.t0);
            FailureMessageBean = _context.t0.FailureMessageBean || {};
            globalMessages = FailureMessageBean.globalMessages || [{}];
            message = globalMessages[0].message || getString('global.service.unavailable');
            store.dispatch(showStopMessage(message));
            store.dispatch(workingEnd());

          case 26:
            _context.next = 29;
            break;

          case 28:
            logger.debug('Biometrics: Only supported in native application');

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 18]]);
  }));

  return function (_x) {
    return _ref4.apply(this, arguments);
  };
})();